const getInitials = (name) => {
  return name && name.length > 0 ? name.substring(0, 1).toUpperCase() : "";
};
const getFontSize = (size) => {
  return Math.min(size / 2.2, 32);
};
export {
  getFontSize,
  getInitials
};
//# sourceMappingURL=avatar.utils.js.map
